import { render } from "./StockLevel.vue?vue&type=template&id=6ffbd328"
import script from "./StockLevel.vue?vue&type=script&lang=js"
export * from "./StockLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__